import { render, staticRenderFns } from "./ProductSubClassDetail.vue?vue&type=template&id=e22571aa&scoped=true"
import script from "./ProductSubClassDetail.vue?vue&type=script&lang=js"
export * from "./ProductSubClassDetail.vue?vue&type=script&lang=js"
import style0 from "./ProductSubClassDetail.vue?vue&type=style&index=0&id=e22571aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_j7knk6mol3vthgvrc443rvn57u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e22571aa",
  null
  
)

export default component.exports